import { Component, OnInit } from '@angular/core';
import { SvgIconService } from '@valg-shared/services/svg-icon.service';
import { FooterLink } from "@valg-shared/components/footer/footer.component";
import { FooterLinkService } from '@shared/services/footerlink.service';

@Component({
  selector: 'valg-dk-root',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.scss' ]
})
export class AppComponent implements OnInit {
  title = 'valg-dk';
  footerLinks: FooterLink[] = [];
  constructor(readonly svgService: SvgIconService, readonly footerService: FooterLinkService){
      this.svgService.init();
  }

  ngOnInit(): void {
    this.footerLinks = this.footerService.getFooterLinks();
  }
}